var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2348 4473 l-3 -217 -111 -22 c-686 -138 -1210 -662 -1348 -1348 l-22 -111 -217 -3 -217 -2 0 -210 0 -210 217 -2 217 -3 22 -111 c138 -686 662 -1210 1348 -1348 l111 -22 3 -217 2 -217 210 0 210 0 2 217 3 217 115 23 c681 136 1206 662 1344 1347 l22 111 217 3 217 2 0 210 0 210 -217 2 -217 3 -22 111 c-138 685 -662 1211 -1344 1347 l-115 23 -3 217 -2 217 -210 0 -210 0 -2 -217z m482 -662 c502 -114 877 -495 986 -1001 26 -119 26 -381 0 -500 -110 -512 -493 -895 -1006 -1006 -126 -27 -392 -25 -516 4 -511 120 -880 494 -990 1002 -26 119 -26 381 0 500 109 505 488 890 985 1000 121 26 148 29 311 24 95 -2 174 -10 230 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 3184 c-111 -23 -224 -86 -311 -173 -251 -252 -252 -650 0 -901 253 -252 651 -253 901 -1 253 254 253 648 0 902 -155 156 -374 220 -590 173z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target-icon.f911654997d7939b48f6708dc5c6202f.svg";
export { ForwardRef as ReactComponent };